import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-map',
  templateUrl: './contact-map.component.html',
  styleUrls: ['./contact-map.component.css']
})
export class ContactMapComponent implements OnInit {

  @Input() office: string;
  
  constructor() { }

  ngOnInit(): void {
  }

}
